import { render } from "./ProgressBarLoading.vue?vue&type=template&id=c9c95cc8"
const script = {}

import "./ProgressBarLoading.vue?vue&type=style&index=0&id=c9c95cc8&lang=scss"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__